import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { AsteriskModule } from '@salesrun/ngx-asterisk';
import { NoAutocompleteModule } from '@salesrun/ngx-no-autocomplete';
import { SrpInputDialogComponent } from './input-dialog/srp-input-dialog.component';
import { SrpQuestionDialogComponent } from './question-dialog/srp-question-dialog.component';
import { DialogService } from './srp-dialog.service';


@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatSnackBarModule,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        // packages
        NoAutocompleteModule,
        AsteriskModule,
    ],
    declarations: [
        SrpQuestionDialogComponent,
        SrpInputDialogComponent,
    ],
    exports: [
        MatDialogModule,
    ],
})

export class DialogModule {
    static forRoot(): ModuleWithProviders<DialogModule> {
        return {
            ngModule: DialogModule,
            providers: [
                DialogService,
            ],
        };
    }
}